import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton, HiddenInput } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { OrthodonticReferralResponseApi } from '../../../../api/OrthodonticReferralResponseApi';
import { IOrthodonticReferralAnswer } from '../../../../models/IOrthodonticReferral';

interface IOrthodonticReferralAnswerButton {
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    isReferralAnswerRequired: boolean;
    hasCompletedTreatmentCode: boolean;
    numberOfOrthodonticReferralTreatments: number;
    numberOfOrthodonticReferralICD10Codes: number;
    isICD10CodeAndTherapyRequired: boolean;
}

export const OrthodonticReferralAnswerButton: React.FunctionComponent<IOrthodonticReferralAnswerButton> = ({ changeSuccessMessage, changeErrorMessage, getOrthodonticReferral, orthodonticReferralId, isReferralAnswerRequired, hasCompletedTreatmentCode, isICD10CodeAndTherapyRequired }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralResponseApi(auth);
    const [isClosing, setIsClosing] = React.useState<boolean>(false);

    const answerOrthodonticReferral = (data: IOrthodonticReferralAnswer) => {
        setIsClosing(true);
        api.saveOrthodonticReferralAnswerAndClose(data, () => {
            document.getElementById("close-answer-orthodontic-referral-modal")?.click();
            getOrthodonticReferral(orthodonticReferralId);
            changeSuccessMessage("Ortodontiremissen har avslutats");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsClosing(false);
        });
    }

    const getModalBodyText = (): string => {
        if (isICD10CodeAndTherapyRequired) {
            return "Minst en ICD10-kod och terapi måste anges";
        }
        if (!hasCompletedTreatmentCode) {
            if (isReferralAnswerRequired) {
                return "Patienten ej rapporterad som färdigbehandlad, vill du avsluta remissen? Glöm inte att ange orsak till avbrott i remissvaret";
            }
            return "Patienten ej rapporterad som färdigbehandlad, vill du avsluta remissen?";
        } else {
            if (isReferralAnswerRequired) {
                return "Är du säker på att du vill skicka remissvar och avsluta ortodontiremissen?"
            }
            return "Är du säker på att du vill avsluta ortodontiremissen?"
        }
    }

    return (
        <>
            <CustomSubmitButton onButtonSubmit={() => { document.getElementById("open-answer-orthodontic-referral-modal")?.click(); }}>{isReferralAnswerRequired ? "Skicka remissvar och avsluta ortodontiremiss" : "Avsluta ortdodontiremiss"}</CustomSubmitButton>
            <CustomButton buttonType={ButtonType.create} buttonText="" id="open-answer-orthodontic-referral-modal" data-toggle="modal" data-target="#answer-orthodontic-referral-modal" hidden />
            <Modal header={isReferralAnswerRequired ? "Skicka remissvar och avsluta remiss" : "Avsluta remiss"} id="answer-orthodontic-referral-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <HiddenInput name="orthodonticReferralId" value={orthodonticReferralId.toString()} />
                    <p>{getModalBodyText()}</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-answer-orthodontic-referral-modal" />
                    {
                        isICD10CodeAndTherapyRequired ?
                            null
                            : <CustomSubmitButton onButtonSubmit={answerOrthodonticReferral} isLoading={isClosing}>Ja</CustomSubmitButton>
                    }
                </ModalFooter>
            </Modal>
        </>
    )
}